type KEYWORD = {
  [key: string]: {
    id: string;
    tooltip: string;
  };
};

export const KEYWORDS: KEYWORD = {
  define: {
    id: "define",
    tooltip: "State the meaning."
  },
  describe: {
    id: "describe",
    tooltip:
      "Give an accurate account of facts, processes or events and combine them logically."
  },
  explain: {
    id: "explain",
    tooltip:
      "Give reasons that something is taking place. Using the word 'because' will help your answer."
  },
  give: {
    id: "give",
    tooltip:
      "Produce a short answer from memory or from information in the question if there is any."
  },
  suggest: {
    id: "suggest",
    tooltip:
      "Apply your knowledge to this new situation and provide a possible explanation."
  }
};

export const joinedKeywordIds = Object.keys(KEYWORDS)
  .map(key => KEYWORDS[key].id)
  .join("|");

export const KATEX_CLASS = "markdown-renderer-katex";
